import material_categoria_model from './material_categoria_model';

export default {
  Codigo: null,
  Descripcion: null,
  CodigoMaterialCategoria: null,
  Activo: null,
  Ancho: 0,
  Alto: 0,
  Largo: 0,
  Espesor: 0,
  Gramaje: 0,
  Densidad: 0,
  Diametro: 0,
  Rendimiento: 0,
  MaterialCategoria: { ...material_categoria_model },
};
